// extracted by mini-css-extract-plugin
module.exports = {"loader":"RecentlyUploaded_loader___T_8B","productListContainer":"RecentlyUploaded_productListContainer__KFK1A"};